import { render, staticRenderFns } from "./FinishAlmostDone.vue?vue&type=template&id=20b899ab"
import script from "./FinishAlmostDone.vue?vue&type=script&lang=js"
export * from "./FinishAlmostDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports